var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header_title"},[_vm._v("数智产业基础数据管理系统")]),_c('Options')],1)}
var staticRenderFns = []

export { render, staticRenderFns }